
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"preserveAspectRatio":"none","viewBox":"0 0 662 344","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 233h284V121H0v4h280v104H0v4zM189 1v41h224V1h-4v37H193V1h-4z","fill":"#30C07C"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 342.095h660V.905h-4v337.19H0v4z","fill":"#484848"}}),_c('path',{attrs:{"fill":"#C6EED1","d":"M655 0h7v3.62h-7zM0 336.665h4V343H0zM653 335h9v9h-9z"}})])
          )
        }
      }
    